import type { AttributeLibraryReadModel } from "@Criteria/Hierarchies/Domain/readmodels";

export class AttributeLibraryViewModel
{
    isOpen = false;

    parentId: number | null = null;
    data: AttributeLibraryReadModel | null = null;

    show(parentId: number)
    {
        this.parentId = parentId;
        this.data = null;
        this.isOpen = true;
    }

    close()
    {
        this.isOpen = false;
        this.parentId = null;
        this.data = null;
    }

    setData(data: AttributeLibraryReadModel)
    {
        this.data = data;
    }

    setUsed(names: string[])
    {
        if (!this.data) return;

        const set = new Set(names);

        this.data.CriteriaTemplates.forEach(t =>
        {
            if (set.has(t.Name))
            {
                t.Used = true;
            }
        });
    }
}
